import RcTimePicker from 'rc-time-picker';
import moment from 'moment';

interface Props {
  value: string;
  onChange: (val: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

const Time12Input = ({ value, onChange, onBlur, placeholder = '—', style }: Props) => {
  const momentValue = value ? moment(value, 'HH:mm') : null;

  const handleChange = (m: moment.Moment | null) => {
    const formatted = m ? m.format('HH:mm') : '';
    onChange(formatted);
  };

  return (
    <RcTimePicker
      value={momentValue}
      onChange={handleChange}
      onClose={onBlur}
      format="h:mm a"
      use12Hours
      showSecond={false}
      minuteStep={5}
      allowEmpty
      placeholder={placeholder}
      inputReadOnly={false}
      style={{ width: 90, ...style }}
      inputIcon={<span />}
      clearIcon={<span />}
    />
  );
};

export default Time12Input;
